/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Button, Box, Link } from "@mui/material";
import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

import { useNavigate } from "react-router-dom";
import { usePersistentState } from "../../contexts/global-context";
import { GetLocalStorage } from "../../utils/local-storage";

const ContactUsTopTabBar = ({
  backgroundColors,
  textColor,
  boxShadow,
  iconColor,
  pages,
  event,
}: any) => {
  const navigate = useNavigate();

  const [state]: any = usePersistentState();
  const [loginInfo, setLoginInfo] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState("transparent");
  const [, setBoxShadows] = useState("none");
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
    navigate("/login");
  };

  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };
  const smoothScroll = (target: string) => {
    const $target = document.querySelector(target);
    if ($target) {
      window.scrollTo({
        top: $target.getBoundingClientRect().top + window.pageYOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      if (position > 0) {
        setBackgroundColor("#2f3138");
        setBoxShadows("0px 3px 5px rgba(0, 0, 0, 0.2)");
      } else {
        setBackgroundColor(backgroundColors);
        setBoxShadows("none");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [backgroundColors]);
  return (
    <AppBar style={{ backgroundColor, boxShadow, position: "fixed" }}>
      <Toolbar>
        <Link
          onClick={() => {
            navigate("/home");
          }}
          style={{ textDecoration: "none", marginTop: 5 }}
          component="button"
        >
          <img
            style={{ height: " 47.3px", width: "110px", margin: 10 }}
            src={require("../../assets/image/eventprix-logo-main.png")}
          />
        </Link>
        <div style={{ flexGrow: 17 }} />
        <Box
          sx={{
            flexGrow: 1,
            display: { xs: "flex", md: "none" },
            marginRight: 1,
          }}
        >
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color={iconColor}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{
              display: { xs: "block", md: "none" },
            }}
          >
            {loginInfo === null ? (
              <div
                style={{
                  flexDirection: "column",
                }}
              >
                <Button
                  onClick={() => {
                    navigate("/home");
                  }}
                  sx={{
                    color: "#000",
                    display: "block",
                    fontSize: 13,
                    textAlign: "left",
                  }}
                >
                  Home
                </Button>
                <Button
                  sx={{
                    color: "#000",
                    display: "block",
                    fontSize: 13,
                    textAlign: "left",
                  }}
                  onClick={() => {
                    navigate(`/home#${event}`);
                  }}
                >
                  Events
                </Button>
                <Button
                  onClick={() => {
                    navigate("/login");
                  }}
                  sx={{
                    color: "#000",
                    display: "block",
                    fontSize: 13,
                    textAlign: "left",
                  }}
                >
                  Create Event
                </Button>
                <Button
                  onClick={() => {
                    navigate("/login");
                  }}
                  sx={{
                    color: "#000",
                    display: "block",
                    fontSize: 13,
                    textAlign: "left",
                  }}
                >
                  Log In
                </Button>
              </div>
            ) : (
              <div
                style={{
                  flexDirection: "column",
                }}
              >
                <Button
                  onClick={() => {
                    navigate("/home");
                  }}
                  sx={{
                    color: "#000",
                    display: "block",
                    fontSize: 13,

                    textAlign: "left",
                  }}
                >
                  Home
                </Button>
                <Button
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                  sx={{
                    color: "#000",
                    display: "block",
                    fontSize: 13,
                    textAlign: "left",
                  }}
                >
                  Dashboard
                </Button>
                <a
                  onClick={(e: any) => {
                    e.preventDefault();
                    smoothScroll("#hostbenefits");
                  }}
                >
                  <Button
                    onClick={() => {
                      navigate(`/home`);
                    }}
                    sx={{
                      color: "#000",
                      display: "block",
                      fontSize: 13,
                    }}
                  >
                    Host Benefits
                  </Button>
                </a>
                <Button
                  onClick={() => {
                    navigate("/dashboard/event/add");
                  }}
                  sx={{
                    color: "#000",
                    display: "block",
                    fontSize: 13,
                    textAlign: "left",
                  }}
                >
                  Create Event
                </Button>

                <Button
                  sx={{
                    color: "#000",
                    display: "block",
                    fontSize: 13,
                    textAlign: "left",
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </div>
            )}
          </Menu>
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
          }}
        >
          {loginInfo === null ? (
            <>
              <Button
                onClick={() => {
                  navigate("/home");
                }}
                sx={{
                  color: textColor,
                  display: "block",
                  fontSize: 16,
                  marginLeft: 3,
                  fontWeight: 600,
                }}
              >
                Home
              </Button>
              <Button
                sx={{
                  color: textColor,
                  display: "block",
                  fontSize: 16,
                  marginLeft: 3,
                  fontWeight: 600,
                }}
                onClick={(e: any) => {
                    e.preventDefault();
                    smoothScroll("#hostbenefits");
                  }}
              >
                Events
              </Button>

              <Button
                onClick={() => {
                  navigate("/login");
                }}
                sx={{
                  // my: 3,
                  color: textColor,
                  display: "block",
                  fontSize: 16,
                  marginLeft: 3,
                  fontWeight: 600,
                }}
              >
                Create Event
              </Button>

              <Button
                onClick={() => {
                  navigate("/login");
                }}
                sx={{
                  // my: 3,
                  color: textColor,
                  display: "block",
                  fontSize: 16,
                  marginLeft: 3,
                  fontWeight: 600,
                }}
              >
                Log In
              </Button>
              <Button
                sx={{
                  // my: 3,
                  color: textColor,
                  display: "block",
                  fontSize: 16,
                  marginLeft: 3,
                  fontWeight: 600,
                }}
                onClick={() => {
                  navigate(`/contact-us`);
                }}
              >
                Contact Us
              </Button>
            </>
          ) : (
            <>
              <a
                onClick={(e: any) => {
                  e.preventDefault();
                  smoothScroll("#home");
                }}
              >
                <Button
                  onClick={() => {
                    navigate("/home");
                  }}
                  sx={{
                    // my: 3,
                    color: textColor,
                    display: "block",
                    fontSize: 16,
                    marginLeft: 3,
                    fontWeight: 600,
                  }}
                >
                  Home
                </Button>
              </a>

              <Button
                onClick={() => {
                  navigate("/dashboard");
                }}
                sx={{
                  // my: 3,
                  color: textColor,
                  display: "block",
                  fontSize: 16,
                  marginLeft: 3,
                  fontWeight: 600,
                }}
              >
                Dashboard
              </Button>

              <Button
                onClick={() => {
                  navigate("/dashboard/event/add");
                }}
                sx={{
                  // my: 3,
                  color: textColor,
                  display: "block",
                  fontSize: 16,
                  marginLeft: 3,
                  fontWeight: 600,
                }}
              >
                Create Event
              </Button>

              <Button
                sx={{
                  // my: 3,
                  color: textColor,
                  display: "block",
                  fontSize: 16,
                  marginLeft: 3,
                  fontWeight: 600,
                }}
                onClick={handleLogout}
              >
                Logout
              </Button>
              <Button
                sx={{
                  // my: 3,
                  color: textColor,
                  display: "block",
                  fontSize: 16,
                  marginLeft: 3,
                  fontWeight: 600,
                }}
                onClick={() => {
                  navigate(`/contact-us`);
                }}
              >
                Contact Us
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default ContactUsTopTabBar;
